/**
 * Enumerates static UI that can be favorited. Dynamic favorites from the CMS are not included here.
 *
 * Updating the values will break existing favorites (backwards compatibility).
 *
 * Entries are purposefully alphabetical to allow for deterministic
 * usage of functions like Object.values()
 */
export enum FavoriteId {
    APP_FOUNDRY = 'app-foundry',
    ARCHIVES = 'archives',
    BEYOND = 'genesys-beyond',
    /** contains temporary fix, check {@link BadgesComponent.toggleFilterToFavoriteItem} for more details. */
    COMMUNITY_QA_SHOW = 'community-qa-show',
    CUSTOMER_SUCCESS = 'customer-success',
    CX_EVOLUTION = 'cx-evolution',
    /** Dev center for both GC CX and GC MCX */
    /** @deprecated do not use -- was used for Dev Center Genesys Engage On-prem, which has been permanently taken offline. */
    DEVELOPER_CENTER_POPULAR = 'developer-center-popular',
    EXPERT_APPS = 'expert-apps',
    GET_STARTED = 'get-started',
    MARKETING_EVENTS = 'marketing-events',
    LATEST_DISCUSSIONS = 'latest-discussions',
    PRODUCT_FUNDAMENTALS = 'product-fundamentals',
    RELATED_COMMUNITIES = 'related-communities',
    PRODUCT_SUPPORT_CENTER = 'product-support-center',
    SUPPORT_CASES = 'support-cases',

    EDU_EVENTS_AND_WEBINARS = 'webinars',
    MY_CONTACTS = 'my-contacts',
    CONNECT_WITH_GENESYS = 'connect-with-genesys',

    NEWS_FROM_GENESYS_ALL = 'news-from-genesys-all',
    NEWS_FROM_GENESYS_ANNOUNCEMENTS = 'news-from-genesys-announcements',
    NEWS_FROM_GENESYS_BLOG = 'news-from-genesys-blog',
    NEWS_FROM_GENESYS_SOCIAL = 'news-from-genesys-social',

    GET_STARTED_MY_PERSONALIZED_VIDEO = 'get-started-my-personalized-video',
    GET_STARTED_STARTER_KIT = 'get-started-starter-kit',
    GET_STARTED_ONBOARDING = 'get-started-onboarding',
    GET_STARTED_SHORT_TRACKS = 'get-started-short-tracks',
    GET_STARTED_USEFUL_LINKS = 'get-started-useful-links',
    GET_STARTED_TIPS_AND_TOOLS = 'get-started-tips-and-tools',

    CERTIFICATIONS_MY_AWARDS = 'certifications-my-awards',
    CERTIFICATIONS_GET_CERTIFIED = 'certifications-get-certified',

    CX_EVOLUTION_GET_STARTED = 'cx-evolution-get-started',
    CX_EVOLUTION_CONNECT = 'cx-evolution-connect',
    CX_EVOLUTION_LEARN_FROM_OTHERS = 'cx-evolution-learn-from-others',

    PRODUCT_HELP_ARTICLES = 'product-help-articles',
    PRODUCT_HELP_VIDEOS = 'product-help-videos',
    PRODUCT_HELP_USE_CASES = 'product-help-use-cases',
    PRODUCT_HELP_DOCUMENTATION = 'product-help-documentation',

    RECOMMENDATIONS = 'recommendations',
    DEVELOPER_CENTER_TOOLS = 'developer-center-tools',
    DEVELOPER_CENTER_POPULAR_TOPICS = 'developer-center-popular-topics',
    DEVELOPER_CENTER_BLOG = 'developer-center-blog',

    OWTGI_WRITE_A_REVIEW = 'owtgi-write-a-review',
    OWTGI_CUSTOMER_MONTHLY_NEWSLETTER = 'owtgi-customer-monthly-newsletter',
    OWTGI_SUPER_HUMAN_SERVICE = 'owtgi-super-human-service',
    OWTGI_PRODUCT_IDEAS_LAB = 'owtgi-product-ideas-lab',
    OWTGI_GENESYS_USER_GROUPS = 'owtgi-genesys-user-groups',
    OWTGI_COLLABORATE_WITH_OUR_UX_TEAM = 'owtgi-collaborate-with-our-ux-team',
    OWTGI_DEVELOPER_NEWSLETTER = 'owtgi-developer-newsletter',
    OWTGI_ADVOCACY_PAYS = 'owtgi-advocacy-pays',

    // "Dummy" favorites. Required in order to make filtering on "Just For Me" section work
    JUST_FOR_ME = 'just-for-me',
    ADDITIONAL_SITES = 'additional-sites',
    MY_FAVORITES = 'my-favorites',

    ACHIEVERS_LOUNGE = 'achievers-lounge',
    ADVOCACY = 'advocacy',
    APPFOUNDRY = 'appfoundry',
    BOOST_YOUR_KNOWLEDGE_WEBINARS = 'boost-your-knowledge-webinars',
    BOOST_YOUR_KNOWLEDGE_WEBINARS_LIBRARY = 'boost-your-knowledge-webinars-library',
    CAPABILITY_ACCELERATOR = 'capability-accelerator',
    CAPABILITY_ACCELERATOR_WEB_MESSAGING = 'capability-accelerator-web-messaging',
    CAPABILITY_ACCELERATOR_PREDICTIVE_ROUTING = 'capability-accelerator-predictive-routing',
    CAPABILITY_ACCELERATOR_AGENT_COPILOT = 'capability-accelerator-agent-copilot',
    CAPABILITY_ACCELERATOR_STA = 'capability-accelerator-speech-and-text-analytics',
    CERTIFICATIONS = 'certifications',
    CHECKOUT_ACTIVITIES = 'community-activities',
    COMMUNITY_LATEST_DISCUSSIONS = 'community-latest-discussions',
    GENESYS_COMMUNITY_YOUTUBE = 'community-youtube',
    DEVELOPER_CENTER = 'developer-center',
    EDUCATION_ENROLLMENTS = 'edu-enrollments',
    EDUCATION_FEATURED_VIDEOS = 'edu-featured-videos',
    EDUCATION_WEBINARS = 'edu-webinars',
    FUNDAMENTALS = 'fundamentals',
    GENESYS_BLOG = 'genesys-blog',
    GENESYS_EVENTS = 'genesys-events',
    GENESYS_NEWS = 'genesys-news',
    GENESYS_SOCIAL = 'genesys-social',
    HELPFUL_LINKS = 'helpful-links',
    PERSONALIZED_VIDEO = 'personalized-video',
    PRODUCT_ANNOUNCEMENTS = 'product-announcements',
    PRODUCT_HELP = 'product-help',
    ROADMAP_ARCHIVES = 'roadmap-archives',
    SHORT_TRACKS = 'short-tracks',
    STARTER_KITS = 'starter-kits',
    STARTER_KITS_GC = 'starter-kit-genesys-cloud-cx',
    STARTER_KITS_WEM = 'starter-kit-genesys-cloud-wem-ex',
    TIPS_AND_TOOLS = 'tips-and-tools',
}
